import React from 'react';
import { observer } from 'mobx-react-lite';
import { OverrideRatesSection } from './OverrideRatesSection';
import { QuotedResultsSection } from './QuotedResultsSection';
import { ContentStyled } from './styles';

export const OverrideQuotedRatesContent: React.FC = observer(() => {
  return (
    <ContentStyled>
      <QuotedResultsSection />
      <OverrideRatesSection />
    </ContentStyled>
  );
});
